import { SessionToast } from '../models/toasts';
import { getUnixTime } from 'date-fns';
import { SystemToast } from './showToast';
import React from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

export const setSessionToast = (message: SystemToast): void => {
  // Timeout is needed to avoid flushSync error: "Warning: flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
  setTimeout(() => {
    const messageCopy = { ...message };
    if (React.isValidElement(message.detail)) {
      const rootElement = document.createElement('div');
      flushSync(() => createRoot(rootElement).render(<BrowserRouter>{message.detail}</BrowserRouter>));
      messageCopy.detail = rootElement.innerHTML;
    }
    if (React.isValidElement(message.summary)) {
      const rootElement = document.createElement('div');
      flushSync(() => createRoot(rootElement).render(<BrowserRouter>{message.summary}</BrowserRouter>));
      messageCopy.summary = rootElement.innerHTML;
    }
    const sessionToast: SessionToast = {
      toast: messageCopy,
      timeSet: getUnixTime(new Date())
    };

    sessionStorage.setItem('toast', JSON.stringify(sessionToast));
  }, 0);
};

export const getSessionToast = (): SystemToast | undefined => {
  const maxSessionToastLifetime = 10;
  const message = sessionStorage.getItem('toast');
  if (!message) {
    return;
  }

  sessionStorage.removeItem('toast');
  try {
    const unserialized: SessionToast = JSON.parse(message);
    if (
      typeof unserialized === 'object' &&
      unserialized.toast &&
      typeof unserialized.toast === 'object' &&
      unserialized.timeSet &&
      Number.isInteger(unserialized.timeSet)
    ) {
      const currentTime = getUnixTime(new Date());
      if (currentTime - unserialized.timeSet < maxSessionToastLifetime) {
        return unserialized.toast;
      }
    }
  } catch (e) {}
  return;
};
